import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import InputWithoutTitle from "../../../components/InputWithoutTitle";
import Dropdown from "../../../components/Dropdown";
import Pagination from "../../../components/Pagination";
import OneCheckBox from "../../../components/OneCheckBox";
import ButtonSelectedItems from "../../../components/ButtonSelectedItems";
import CheckItem from "../../../components/CheckItem";
import AddATKResultDialog from "./AddATKResultDialog";
import TemperatureTable from './TemperatureTable'

export default function TempaturePage() {
  const [isShow, setIsShow] = useState(false);
  const [dataSelect, setDataSelect] = useState([])

  const rowTableLogRealtime = [
    {
      title: "No",
      dataIndex: "no",
      key: "no",
    },
    {
      title: "Firstname",
      dataIndex: "firstname",
      key: "firstname",
    },
    {
      title: "Lastname",
      dataIndex: "lastname",
      key: "lastname",
    },
    {
      title: "Temp",
      dataIndex: "temp",
      key: "temp",
    },
    {
      title: "Result",
      dataIndex: "result",
      key: "result",
    },
    {
      title: "Date / time",
      dataIndex: "datetime",
      key: "datetime",
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
    },
    {
      title: "Room",
      dataIndex: "room",
      key: "room",
    },
    {
      title: "Advisor",
      dataIndex: "advisor",
      key: "advisor",
    },
  ];

  return (
    <div>
      <br />
      <Row>
        <Col xs={12} sm={12} md={8} lg={8} xl={8}>
          <InputWithoutTitle />
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4}>
          <Dropdown
            items={["1/2564", "2/2564", "1/2563", "2/2563"]}
            itemCallback={(item) => {
              console.log(item);
            }}
            hasFilter={true}
          />
        </Col>
      </Row>

          <div className="box-on-top-temperature-page-by-nile">
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={4}>
    
            <div>
              <p className="txt-sub-explanation1 text-header-set-point-temp-filter">Set point Temp</p>
              <input className="text-field" />
              <OneCheckBox callBack={(checked) => {}} title={"Highlight"} style={{ marginLeft:'10px', marginTop:'5px' }} />
              <OneCheckBox
                callBack={(checked) => {}}
                title={"Hight-Temp-Top"}
                style={{ marginLeft:'10px' }}
              />
            </div>
            </Col>
        
            <Col xs={12} sm={12} md={6} lg={6} xl={4}>
         
            <div className="box-dash-temperature-page-by-nile">
              <div className="row-jcsb">
                <p className="txt-main-content4">Hight-Temp-Number</p>
                <p className="txt-main-content4">135 คน</p>
              </div>
              <div className="row-jcsb">
                <p className="txt-main-content4">Most Temp</p>
                <p className="txt-main-content4">39.5</p>
              </div>
              <div className="row-jcsb">
                <p className="txt-main-content4">Env Temp</p>
                <p className="txt-main-content4">36.8</p>
              </div>
            </div>
            </Col>

            <Col xs={12} sm={12} md={6} lg={6} xl={4}>
         
           <div className="box-dash-temperature-page-by-nile">
              <div className="row-jcsb">
                <p className="txt-main-content4">Hight-Temp-Number</p>
                <p className="txt-main-content4">135 คน</p>
              </div>
              <div className="row-jcsb">
                <p className="txt-main-content4">Most Temp</p>
                <p className="txt-main-content4">39.5</p>
              </div>
              <div className="row-jcsb">
                <p className="txt-main-content4">Env Temp</p>
                <p className="txt-main-content4">36.8</p>
              </div>
            </div> 
           </Col>
           </Row>
          </div>

      <Row>
        <Col>
        <br />
        <TemperatureTable />
          {/* <div className="box-table-temperature">
            <CheckItem callBack={(checked) => {}} />
          </div> */}
        </Col>
      </Row>

      <Row>
        <Col>
          <div className="row-jcfe-my2">
            <Pagination />
          </div>
        </Col>
      </Row>

      <Row>
        <Col>
          <ButtonSelectedItems
            addClick={() => {
              // resetQuery();
              setIsShow(true);
            }}
            addTitle={"Add ATK Result"}
          />
          <AddATKResultDialog
            isShow={isShow}
            backgroundClick={() => {
              setIsShow(false);
            }}
            cancelClick={() => {
              setIsShow(false);
            }}
          />
        </Col>
      </Row>
    </div>
  );
}

// import React, { useState } from "react";
// import InputWithoutTitle from "../../../components/InputWithoutTitle";
// import Dropdown from "../../../components/Dropdown";
// import Pagination from "../../../components/Pagination";
// import OneCheckBox from "../../../components/OneCheckBox";
// import ButtonSelectedItems from "../../../components/ButtonSelectedItems";
// import CheckItem from "../../../components/CheckItem";
// import AddATKResultDialog from "./AddATKResultDialog";
// import TemperatureTable from "./TemperatureTable";
// export default function TempaturePage() {
//   const [isShow, setIsShow] = useState(false);

//   return (
//     <div className="pt2">
//       <div className="grid70-30">
//         <InputWithoutTitle />
//         <Dropdown
//           items={["1/2564", "2/2564", "1/2563", "2/2563"]}
//           itemCallback={(item) => {
//             console.log(item);
//           }}
//           hasFilter={true}
//         />
//       </div>
//       <div className="box-on-top-temperature-page">
//         <div>
//           <p className="txt-sub-explanation1">Set point Temp</p>
//           <input className="text-field"></input>
//           <OneCheckBox callBack={(checked) => {}} title={"Highlight"} />
//           <OneCheckBox callBack={(checked) => {}} title={"Hight-Temp-Top"} />
//         </div>
//         <div className="box-dash-temperature-page">
//           <div className="row-jcsb">
//             <p className="txt-main-content4">Hight-Temp-Number</p>
//             <p className="txt-main-content4">135 คน</p>
//           </div>
//           <div className="row-jcsb">
//             <p className="txt-main-content4">Most Temp</p>
//             <p className="txt-main-content4">39.5</p>
//           </div>
//           <div className="row-jcsb">
//             <p className="txt-main-content4">Env Temp</p>
//             <p className="txt-main-content4">36.8</p>
//           </div>
//         </div>
//         <div className="box-dash-temperature-page">
//           <div className="row-jcsb">
//             <p className="txt-main-content4">Hight-Temp-Number</p>
//             <p className="txt-main-content4">135 คน</p>
//           </div>
//           <div className="row-jcsb">
//             <p className="txt-main-content4">Most Temp</p>
//             <p className="txt-main-content4">39.5</p>
//           </div>
//           <div className="row-jcsb">
//             <p className="txt-main-content4">Env Temp</p>
//             <p className="txt-main-content4">36.8</p>
//           </div>
//         </div>
//       </div>
//       <TemperatureTable /> 
//       <div className="row-jcfe-my2">
//         <Pagination />
//       </div>
//       <ButtonSelectedItems
//         addClick={() => {
//           // resetQuery();
//           setIsShow(true);
//         }}
//         addTitle={"Add ATK Result"}
//       />
//       <AddATKResultDialog
//         isShow={isShow}
//         backgroundClick={() => {
//           setIsShow(false);
//         }}
//         cancelClick={() => {
//           setIsShow(false);
//         }}
//       />
//     </div>
//   );
// }
